import { createStyles } from 'antd-style'

export const useStyle = createStyles({
  modalApplicationsRow: {
    overflowY: 'scroll',
    paddingBlock: '20px'
  }
})
